export default __webpack_public_path__ + "static/media/myresume.5a22db06.pdf";